function CenteredRow({children}){
    return (
    <div className="row">
        <div className="col-lg-10 mx-auto">{children}</div>
    </div>);
}

export default CenteredRow;